import React, {useEffect, useState} from 'react';
import {Link, useLocation, useOutletContext, useParams, useSearchParams} from 'react-router-dom';
import TitleMain from "../../../components/Title/TitleMain";
import {useModal} from "../../../contexts/ModalContext";
import {useUser} from "../../../contexts/UserContext";
import AxiosConfig from "../../../services/AxiosConfig";
import {useBreadcrumb} from "../../../contexts/BreadcrumbContext";
import {generateBreadcrumbSegmentsAdmin} from "../../../services/BreadcrumbService";
import ContratCreation from "../../../components/Admin/Entreprise/EntrepriseCreation";
import EntreprisesVue from "../../../components/Admin/Entreprise/EntreprisesVue";
import EntrepriseVue from "../../../components/Admin/Entreprise/EntrepriseVue";
import EntrepriseCreation from "../../../components/Admin/Entreprise/EntrepriseCreation";
import ErrorPage from "../../Erreurs/ErrorPage";
import EntrepriseVue2 from "../../../components/Admin/Entreprise/EntrepriseVue2";

function AdminEntreprisePage() {
    const {user} = useUser();
    const {showModal, hideModal} = useModal();
    const [myApiData, setMyApiData] = useState([]);
    const {entrepriseId} = useParams();
    const [entreprise, setEntreprise] = useState({});
    const { updateBreadcrumb, updateDynamicBreadcrumb } = useBreadcrumb();
    const [ searchParams] = useSearchParams();
    const mode = searchParams.get('mode') || 'default';
    const modeOptions = {
        'creation': <EntrepriseCreation entreprise={myApiData} />,
        'consultation': <EntrepriseVue entreprise={myApiData} />,
        'consultation2': <EntrepriseVue2 entreprise={myApiData} />,
        'default': <EntrepriseVue2 entreprise={myApiData} />
    };
    const ComponentToRender = modeOptions[mode] || modeOptions['default'];


    const handleSuccess = (children = "Note enregistrée avec succès") => {
        showModal('success', {children: children, timeout: 1500});
    };
    const handleError = (children = "Une erreur est survenue") => {
        showModal('error', {children: children, timeout: 1500});
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await AxiosConfig.get(`/admin/entreprises/${entrepriseId}`);

                const parseData = response.data.myEntreprise;
                setMyApiData(parseData);
                setEntreprise(response.data.myEntreprise);

            } catch (error) {
                console.error('error', error);
            }
        })();
    }, [user]);

    useEffect(() => {
        updateDynamicBreadcrumb(generateBreadcrumbSegmentsAdmin({ entreprise }));
    }, [ entreprise ]);

    if (!myApiData || Object.keys(myApiData).length === 0) {
        return <ErrorPage title={"Page inaccessible"}/>;
    }

    return ( ComponentToRender )
}

export default AdminEntreprisePage;
